
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import OverflowTextTooltip from '@/components/molecules/OverflowTextTooltip.vue'
import ButtonFloatMenu from '@/components/organisms/manage/ButtonFloatMenu.vue'
import GradeTip from '@/components/organisms/GradeTip.vue'
import { AvatarCode } from '@/const/AvatarCode'
import { StudentList } from '@/models/manage/StudentList'

/**
 * 生徒一覧テーブル
 */
@Component({
  components: {
    ImageBase,
    OverflowTextTooltip,
    ButtonFloatMenu,
    GradeTip,
  },
})
export default class StudentListTable extends Vue {
  /** 生徒一覧 */
  @Prop()
  private studentList!: StudentList[]

  /** 編集メニュー表示イベント */
  @Prop()
  private eventClickEditButton!: (
    event: Event,
    userId: number,
    lockedStatus: string,
    registerType: number | null
  ) => Promise<void>

  /** 選択済生徒リスト(id一覧) */
  public checkedStudentList: number[] = []

  /** 全件チェックボックス */
  public isCheckedAll: boolean = false

  /**
   * 「教室」カラムの有無
   *
   * @returns 「教室」カラムがあればtrue
   */
  private get hasColumnBranch(): boolean {
    return !!this.$scopedSlots.headerBranch
  }

  /**
   * 全件チェックボックスの状態を変更し、ユーザID一覧を更新
   */
  private clickMainCheckbox(): void {
    this.isCheckedAll = !this.isCheckedAll
    if (this.isCheckedAll) {
      this.checkedStudentList = this.studentList.map((student) => student.userId)
      return
    }
    this.checkedStudentList = []
  }

  /**
   * 選択済生徒リストのクリア
   */
  public clearSelectedStudents(): void {
    this.checkedStudentList = []
  }

  /**
   * 選択済生徒数を判定し、全選択チェックボックスの状態に反映する
   */
  @Watch('checkedStudentList')
  private checkSelectedStudentList(): void {
    // 選択済生徒リストの人数が生徒一覧より少ない場合、全選択チェックをクリア
    if (this.checkedStudentList.length < this.studentList.length) {
      this.isCheckedAll = false
    }
  }

  /**
   * アイコンコードからアイコン画像のパスを引き当てる
   *
   * @param code アイコンコード
   * @returns アイコン画像のパス
   */
  private iconUrl(code: string | null): string {
    const avatar = AvatarCode.findByCode(code)
    return avatar.path
  }
}
